<div class="flex flex-col gap-y-2">
  @let vm = offshoreReportStore.vm();
  <re-offshore-reporting-options></re-offshore-reporting-options>
  <p-divider></p-divider>

  @if (vm.isSectionVisible('operational', 'reportDetails')) {
    <re-report-details id="reportDetails" />
    <p-divider />
  }

  @if (vm.isSectionVisible('operational', 'voyageDetails')) {
    <re-voyage-details id="voyageDetails" />
    <p-divider />
  }

  @if (vm.isSectionVisible('operational', 'vesselDetails')) {
    <re-vessel-details id="vesselDetails" />
    <p-divider />
  }
  @if (vm.isSectionVisible('operational', 'reportTime')) {
    <re-report-time id="reportTime" />
    <p-divider />
  }
  @if (vm.isSectionVisible('operational', 'portAndPosition')) {
    <re-port-and-position id="portAndPosition" />
    <p-divider />
  }
  @if (vm.isSectionVisible('operational', 'stabilityConditions')) {
    <re-stability-conditions id="stabilityConditions" />
    <p-divider />
  }

  @if (vm.isSectionVisible('operational', 'portOperationsTimestamp')) {
    <re-port-operations-timestamp id="portOperationsTimestamp" />
    <p-divider />
  }
  @if (vm.isSectionVisible('operational', 'operatingConditions')) {
    <re-operating-conditions id="operatingConditions" />
    <p-divider />
  }
  @if (vm.isSectionVisible('operational', 'nextPort')) {
    <re-next-port id="nextPort" />
    <p-divider />
  }
  @if (vm.isSectionVisible('operational', 'crewAndPassengers')) {
    <re-crew-and-passengers id="crewAndPassengers" />
    <p-divider />
  }
  @if (vm.isSectionVisible('operational', 'miscellaneous')) {
    <re-miscellaneous id="miscellaneous" />
    <p-divider />
  }
  @if (operationalStore.dynamicSection()) {
    <re-dynamic-form
      tabId="operational"
      [events]="events"
      [formConfig]="
        offshoreReportStore.formConfig()?.tabs?.['operational']?.customFields ??
        []
      "
      [storeSectionState]="operationalStore.dynamicSection()"
      class="flex flex-col gap-y-2"
    ></re-dynamic-form>
  }
</div>
